function initScrollTo() {
  function headerOffset() {
    const header = document.querySelector('.section-header');
    if (!header) return 0;
    const position = getComputedStyle(header).position;
    if (position !== 'sticky' && position !== 'fixed') return 0;
    return header.getBoundingClientRect().height;
  }

  function animateScroll(targetY) {
    const start = window.scrollY;
    const distance = targetY - start;
    if (Math.abs(distance) < 2) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.scrollTo(0, targetY);
      return;
    }

    const duration = Math.min(900, Math.max(450, Math.abs(distance) * 0.45));
    const startTime = performance.now();

    function ease(t) {
      return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
    }

    function step(now) {
      const progress = Math.min(1, (now - startTime) / duration);
      window.scrollTo(0, start + distance * ease(progress));
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  document.addEventListener('click', function (event) {
    const link = event.target.closest('.scroll-to');
    if (!link) return;

    const href = link.getAttribute('href') || '';
    if (!href.startsWith('#')) return;

    const target = document.getElementById(href.slice(1));
    if (!target) return;

    event.preventDefault();
    const top = target.getBoundingClientRect().top + window.scrollY - headerOffset();
    animateScroll(Math.max(0, top));
    history.pushState(null, '', href);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initScrollTo);
} else {
  initScrollTo();
}

